import React from 'react';
import { Box } from '@material-ui/core';
import DashboardLayout from 'layouts/Dashboard';
import { HeatMapContainer } from './components/HeatMapContainer';
import { useTranslation } from 'react-i18next';

export function HeatMap() {
  const { t } = useTranslation();

  return (
    <DashboardLayout
      title={(t && typeof t === 'function') ? (t('sidebar.option.title.heatmap') || 'Mapa de calor') : 'Mapa de calor'}
      callbackFromParent={() => {}}
      isFirstTime={true}
    >
      <Box>
        <HeatMapContainer />
      </Box>
    </DashboardLayout>
  );
}
